import { Table } from '../../Table';
import { Errors } from '../style';
import useRankingTable from '../../../hooks/useRankingTable';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLabels = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  sub_asset_type: {
    name: 'Sub Asset Type',
    isStatic: false
  },
  aggregated_value_amount: {
    name: 'Aggregated value',
    isStatic: false
  }
};

export function PrincipalInstruments({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_PRINCIPAL_INSTRUMENT,
    onChangeFund,
    schema: schema.AIFM_PRINCIPAL_INSTRUMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.AIFM_PRINCIPAL_INSTRUMENT?.field_names || [],
    order: 32,
    tableName: 'AIFM_PRINCIPAL_INSTRUMENT',
    columnLables: columnLabels,
    isMultiFunds,
    funds
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_PRINCIPAL_INSTRUMENT?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.AIFM_PRINCIPAL_INSTRUMENT?.find(
    item => item?.errors?.general
  )?.errors?.general as any;

  return (
    <>
      <Errors id="fca-reporttables-principal-instruments-errors">
        {isRequiredTable && (
          <li id="fca-reporttables-principal-instruments-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`fca-reporttables-principal-instruments-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <StyledTables id="fca-reporttables-principal-instruments-group">
        {tables.map((rows, index) => (
          <Table
            id={`fca-reporttables-principal-instruments-table-${index + 1}`}
            key={index + 'PRINCIPAL_EXPOSURES'}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          />
        ))}
      </StyledTables>
    </>
  );
}
